import { Component } from '@angular/core';
import {AlertController, App, IonicPage, NavController, NavParams} from 'ionic-angular';
import {ApiCourseDataProvider} from "../../providers/api-course-data/api-course-data";
import {CourseVideo} from "../../models/course-video";
import {AppVideoMyWayPage} from "../app-video-my-way/app-video-my-way";
import {ContentTranslationProvider} from "../../providers/content-translation/content-translation";

/**
 * Generated class for the AppMyWayPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-app-my-way',
  templateUrl: 'app-my-way.html',
})
export class AppMyWayPage {

  myWayPage: any = AppVideoMyWayPage;

  __userClosed: number = 0;
  __userAvailable: number = 0;

  closedVideos: Array<CourseVideo>;
  activeVideo: CourseVideo;
  futureVideos: Array<CourseVideo>

  constructor(public navCtrl: NavController, public navParams: NavParams, private app: App, private apiCourseData: ApiCourseDataProvider, public alertCtrl: AlertController, public contentTranslation: ContentTranslationProvider) {
    this.closedVideos = new Array<CourseVideo>();
    this.futureVideos = new Array<CourseVideo>();
  }

  openMyWay(video: CourseVideo) {
    this.app.getRootNav().push(AppVideoMyWayPage, video, {animate: false});
  }

  goBack() {
    this.navCtrl.parent.select(0);
  }

  ionViewDidLoad() {
    var me = this;
    this.apiCourseData.getMyWayCourses().then(data => {
      let i = 0;
      data.map(video => {
        if(video._userStatus == 3) {
          me.closedVideos.push(video);
          me.__userClosed++;
        }
        if(video._userStatus == 1) {
          me.futureVideos.push(video);
        }
        if(video._userStatus == 2) {
          me.activeVideo = video;
        }

        video._localPosition=i++;
        me.__userAvailable++;
      })
    })

  }

  showMoreInfo() {
    const alert = this.alertCtrl.create({
      title: this.contentTranslation.translateContent('My way more info '),
      subTitle: this.contentTranslation.translateContent('My way more info text'),
      buttons: [
        {
          text: 'OK',
        },
        {
          text: '×',
          cssClass: 'close-button'
        }
      ],
      cssClass: 'ip-alert ip-with-close'
    });
    alert.present();
  }

  showNotAvailableInfo() {
    const alert = this.alertCtrl.create({
      title: this.contentTranslation.translateContent('My way not available info '),
      subTitle: this.contentTranslation.translateContent('My way mnot available text'),
      buttons: [
        {
          text: 'OK',
        },
        {
          text: '×',
          cssClass: 'close-button'
        }
      ],
      cssClass: 'ip-alert ip-with-close'
    });
    alert.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/app-my-way/app-my-way.ts